export class MultiFilterBaseModel {
    name;
    id;
    filterType;
    data;
    width;
    singular;
    constructor(options) {
        this.name = options.name;
        this.id = options.id;
        this.filterType = options.filterType;
        this.data = options.data || [];
        this.width = options.width || 600;
        this.singular = options.singular || this.name;
    }
    isEmpty(filter) { }
    getDisplayedName() { }
}
//# sourceMappingURL=osd-multi-filter-base.js.map